
import { createTheme } from '@mui/material/styles';
import colors from '../Styles/style.css';


/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const links = () => [
    {
        rel: 'stylesheet',
        href: colors
    }
];

const defaultTheme1 = createTheme({
    typography: {
        fontFamily: [
            'IRNazaninBold',
        ].join(','),
    },
palette:{
primary:{
  main:'#028391',
  contrastText:'#fff'
}
}    });
const defaultTheme = createTheme({
    direction:"rtl",
      components:{
        MuiFormLabel: {
          styleOverrides: {
            root: {
              color: '#206A5D',
              fontFamily:'Vazir-Medium'
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            notchedOutline: {
              fontSize: '1.2em !important',
               fontFamily:'Vazir-Medium'
            }
          }
        },
        MuiInputLabel: {
          styleOverrides: {
            outlined: {
              '&.MuiInputLabel-shrink': {
                fontSize: '1.2em !important',
              fontFamily:'Vazir-Medium',
               color:'#206A5D',
              }
            }
          }
        },
        MuiDataGrid: {
          styleOverrides: {
            root: {
              '& .MuiDataGrid-columnHeaderTitle':{fontSize:14},
              '& .MuiDataGrid-cell':{fontSize:12}
            }
          }
        }
      },
      typography: {
        fontSize: 14,
        fontFamily: [
          'Vazir-Medium',
        ].join(','),
      },
      palette: {
        primary: {
          main: '#206A5D',
          contrastText: '#fff'
        },
        secondary: {
          main: '#81B214',
          contrastText: '#fff'
        },
        third:{
          main: '#86A789',
          contrastText: '#fff'
        },
        beige:{
          main:'#F1F1E8',
          contrastText: '#000'
        }
      }
    });

export default defaultTheme;

